export const ACCESS_ROLES = ["admin", "engineer", "operator", "viewer", "customer"];

export function accessError(error) {
    const body = error?.response?.data;
    if (!body) return "Unable to reach the server. Your changes were not confirmed.";
    const flatten = (value) => {
        if (Array.isArray(value)) return value.map(flatten).join(" ");
        if (value && typeof value === "object") {
            return Object.entries(value).map(([key, entry]) => `${key}: ${flatten(entry)}`).join(" ");
        }
        return String(value ?? "");
    };
    return flatten(body.detail ?? body);
}

export function localExpiry(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function quotaValue(value) {
    if (value === "") return null;
    if (!/^\d+$/.test(String(value)) || Number(value) > 2147483647) {
        throw new Error("Limits must be whole numbers from 0 to 2147483647, or blank for unlimited.");
    }
    return Number(value);
}

export function tagsForGroups(groups, selected) {
    const found = new Set(selected.map(Number));
    let changed = true;
    while (changed) {
        changed = false;
        for (const group of groups) {
            if (found.has(Number(group.parent_id)) && !found.has(group.id)) {
                found.add(group.id);
                changed = true;
            }
        }
    }
    return found;
}

export function accessibleTagCount(tags, groups, directIds, groupIds) {
    const inherited = tagsForGroups(groups, groupIds);
    const direct = new Set(directIds.map(Number));
    return new Set(tags.filter((tag) => direct.has(tag.id) || inherited.has(tag.group_id)).map((tag) => tag.id)).size;
}

export function resourceOwner(resource) {
    return resource.access_allocation__administrator_id ?? null;
}

export function resourcesForUser(catalog, user) {
    const owner = user.administrator;
    const servers = new Set(catalog.servers.filter((row) => resourceOwner(row) === owner).map((row) => row.id));
    return {
        tags: catalog.tags.filter((row) => servers.has(row.server_id)),
        groups: catalog.groups.filter((row) => resourceOwner(row) === owner),
        pages: catalog.pages.filter((row) => resourceOwner(row) === owner),
    };
}
